if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"loader": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"apps_placement-tool_src_entries_app_js":1,"apps_reviews_widget_src_entries_app_js":1,"apps_reviews_star-rating_src_entries_app_js":1,"apps_reperks_widget_src_entries_app_js":1,"apps_aov-progress-bar_src_entries_app_js":1,"apps_recommender_src_entries_app_js":1,"apps_prompt_src_entries_app_js":1,"apps_back-in-stock_src_entries_app_js":1,"apps_back-in-stock_floating-button_src_entries_app_js":1,"apps_back-in-stock_inline-button_src_entries_app_js":1,"apps_back-in-stock_inline-text_src_entries_app_js":1,"apps_back-in-stock_inline-form_src_entries_app_js":1,"apps_placement-tool_src_containers_Placement_Topbar_index_jsx":1,"apps_placement-tool_src_containers_Placement_Placeholder_index_jsx":1,"apps_reviews_widget_src_containers_ReviewsWidget_index_jsx":1,"apps_reviews_star-rating_src_containers_StarRating_index_jsx":1,"apps_reperks_widget_src_containers_ReperksWidget_index_jsx":1,"apps_recommender_src_containers_Recommender_index_jsx":1,"apps_prompt_src_containers_Prompt_index_jsx":1,"apps_back-in-stock_src_containers_BackInStock_index_jsx":1,"apps_back-in-stock_floating-button_src_containers_FloatingButton_index_jsx":1,"apps_back-in-stock_inline-button_src_containers_InlineButton_index_jsx":1,"apps_back-in-stock_inline-text_src_containers_InlineText_index_jsx":1,"apps_back-in-stock_inline-form_src_containers_InlineForm_index_jsx":1,"apps_reviews_widget_src_containers_ReviewsWidget_SubmittedModal_index_jsx":1,"apps_reviews_widget_src_containers_ReviewsWidget_WriteReviewModal_index_jsx":1,"apps_reperks_widget_src_containers_ReperksWidget_Launcher_Extended_index_jsx":1,"apps_reperks_widget_src_containers_ReperksWidget_Launcher_Minimal_index_jsx":1,"apps_reperks_widget_src_containers_ReperksWidget_Container_index_jsx":1,"apps_prompt_src_containers_Prompt_Page_index_jsx":1,"apps_prompt_src_containers_Prompt_LauncherContainer_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_TextBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_ImageBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_ButtonBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_DateBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_DividerBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_SpacerBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_InputBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_TextareaBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_SelectBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_CheckboxBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_RadioBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_ProductListBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_CountdownBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_VideoBlock_index_jsx":1,"apps_prompt_src_containers_Prompt_Block_HtmlBlock_index_jsx":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr